/**
 *
 * n.b. The BE allows for multiple user ids
 *
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import debounce from "debounce-promise"

import {SelectAsync} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import userService from "@irati/identity/services/users"

import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import authentication from "@irati/auth"

export const PROPERTY = "preferences.emails.notificationUsers.results"
export const schema = Validation.array()

import getNotificationUsersSearchText from "./NotificationUsersSearchText"

class NotificationUsers extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    hint: PropTypes.string
  }

  static defaultProps = {
    validation: schema,
    label: "Send admin emails to the following people",
    placeholder: "Start typing the name of the person you want to add...",
    hint: "You need to type at least 3 characters",
    name: PROPERTY,
    valueKey: "id",
    labelKey: "email",
    autoload: false,
    arrowRenderer: null,
    optionRenderer: (user) => <div>{firstnameLastname(user)}</div>,
    valueRenderer: (user) => <div>{firstnameLastname(user)}</div>
  }

  constructor(props) {
    super(props)
    this.state = {
      query: null
    }

    this.load = debounce(this.load, 500)
  }

  handleChange = (value) => {
    const {name, onChange, schedule} = this.props
    onChange(schedule, name, value)
  }

  load = (query) => {
    if (query && query.length >= 3) {
      return this.getUsers(query)
    }
    return Promise.resolve({options: []})
  }

  getUsers = (q) => {
    const params = {
      tenantId: authentication.userTenant().uuid,
      deactivated: "no",
      limit: 9999,
      role: "user",
      q
    }
    return userService({params}).then(({results}) => results)
  }

  getPromptText = () => {
    const {query} = this.state

    if (query && query.length >= 3) {
      return "No users found."
    }
    return this.props.hint
  }

  render() {
    const idNamespace = id("NotificationUserIds", this.props)
    const {name, schedule, autoload, ...props} = this.props
    const value = get(schedule, name)

    return (
      <SelectAsync
        loadOptions={this.load}
        {...props}
        defaultOptions={autoload}
        onInputChange={(query) => this.setState({query})}
        onChange={this.handleChange}
        id={idNamespace}
        name={name}
        value={value}
        isMulti
        filterOptions={false}
        autoComplete={false}
        components={{
          NoOptionsMessage: getNotificationUsersSearchText(this.getPromptText())
        }} />
    )
  }
}

export default NotificationUsers
